document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.faq-tab-btn')
  const panels = document.querySelectorAll('.faq-panel')

  if (!tabs.length || !panels.length) return

  const switchTab = targetPanelId => {
    // Update Aria Context and Visibility
    tabs.forEach(tab => {
      const isSelected = tab.getAttribute('data-target') === targetPanelId
      tab.setAttribute('aria-selected', isSelected)
    })

    panels.forEach(panel => {
      if (panel.id === targetPanelId) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })
  }

  // Keyboard navigation and click logic
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      switchTab(tab.getAttribute('data-target'))
    })

    tab.addEventListener('keydown', e => {
      const focusableTabs = Array.from(tabs)
      const index = focusableTabs.indexOf(tab)
      let nextIndex = null

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        nextIndex = (index + 1) % focusableTabs.length
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        nextIndex = (index - 1 + focusableTabs.length) % focusableTabs.length
      }

      if (nextIndex !== null) {
        e.preventDefault()
        focusableTabs[nextIndex].focus()
        switchTab(focusableTabs[nextIndex].getAttribute('data-target'))
      }
    })
  })

  // Accordion details toggle logic for smooth closing animation
  const details = document.querySelectorAll('.faq-accordion')
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', e => {
      // Allow link clicks inside rich text
      if (e.target.tagName === 'A') return

      // Close all other accordions when one is opened (optional logic)
      details.forEach(detail => {
        if (detail !== targetDetail && detail.hasAttribute('open')) {
          detail.removeAttribute('open')
        }
      })

      // Update URL hash for deeplinking into specific questions
      // Wrapped in setTimeout to trigger after details native state is updated
      setTimeout(() => {
        if (targetDetail.hasAttribute('open')) {
          history.replaceState(null, null, `#${targetDetail.id}`)
        } else if (window.location.hash === `#${targetDetail.id}`) {
          // If closing the active URL hash, clear the hash
          history.replaceState(null, null, ' ')
        }
      }, 10)
    })
  })

  // Handle Initial Deeplink Hash
  const hash = window.location.hash
  if (hash) {
    // Check if hash matches an accordion question ID
    const targetAccordion = document.querySelector(hash)
    if (targetAccordion && targetAccordion.classList.contains('faq-accordion')) {
      const parentPanel = targetAccordion.closest('.faq-panel')
      if (parentPanel) {
        switchTab(parentPanel.id)
        targetAccordion.setAttribute('open', '')

        // Slight delay to allow layout to settle before scrolling
        setTimeout(() => {
          targetAccordion.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100)
      }
    } else {
      // Fallback: Check if hash matches a Tab ID
      const targetTabBtn = document.querySelector(`[data-target="panel-${hash.substring(1)}"]`)
      if (targetTabBtn) {
        switchTab(`panel-${hash.substring(1)}`)
      }
    }
  }
})
